var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "video-control-container" }, [
    _vm.pin ? _c("div", { staticClass: "control-info pin" }) : _vm._e(),
    _vm.isPlayingWhiteNoise
      ? _c("div", { staticClass: "control-info noise" })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }